import React from 'react';
import { styled } from '@mui/material/styles';
import { withFormsy } from 'formsy-react';
import { pick } from 'lodash';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import FormLabel from '@mui/material/FormLabel';
import Slider from '@mui/material/Slider';

const PREFIX = 'SliderFormsy';

const classes = {
  marked: `${PREFIX}-marked`,
  mark: `${PREFIX}-mark`,
  markLabel: `${PREFIX}-markLabel`,
};

const StyledFormControl = styled(FormControl)({
  [`& .${classes.marked}`]: {
    marginBottom: 30,
  },
  [`& .${classes.mark}`]: {
    backgroundColor: '#bfbfbf',
    height: 8,
    width: 3,
    marginTop: -3,
  },
  [`& .${classes.markLabel}`]: {
    paddingLeft: 3,
    // transform: "translate(-16px, 5px) rotate(-90deg)",
  },
});

function SliderFormsy(props) {
  const importedProps = pick(props, [
    'max',
    'min',
    'value',
    'valueLabelFormat',
    'step',
    'disabled',
  ]);
  let value = props.min || 1;
  const end = props.max || 10;
  const step = props.step || 1;
  const marks = [];
  while (value < end) {
    marks.push({ value, label: value });
    value += step;
  }
  marks.push({ value: end, label: end });

  const handleChange = (event, val) => {
    props.setValue(val);
    if (props.onChange) {
      props.onChange(event);
    }
  };

  const { label, description } = props;

  return (
    <StyledFormControl>
      <FormLabel>{label}</FormLabel>
      <Slider
        marks={marks}
        track={false}
        valueLabelDisplay="off"
        aria-labelledby="discrete-slider"
        onChange={handleChange}
        {...importedProps}
      />
      {description && <FormHelperText>{description}</FormHelperText>}
    </StyledFormControl>
  );
}

export default React.memo(withFormsy(SliderFormsy));
